// extracted by mini-css-extract-plugin
export default {"material":"cxMHL","inner":"_2tGi","icon":"yGRwx","text":"RDcDN"};